document.addEventListener('DOMContentLoaded', function () {
    function toggleVipFaq($question) {
        var $answer = $question.next('.answer');
        if ($answer.is(':hidden')) {
            $question.addClass('minus').attr('aria-expanded', 'true');
        } else {
            $question.removeClass('minus').attr('aria-expanded', 'false');
        }
        $answer.slideToggle();
    }

    $('.faq_box .vip-faq .question').click(function () {
        toggleVipFaq($(this));
    });

    // ADA：button 的 Enter 会走原生 click；挡住全局 Enter→click，避免切换两次
    $('.faq_box .vip-faq .question').on('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.repeat) return;
        event.stopImmediatePropagation();
    });
});
